export function tripStatus(status) {
    if(status == 'completed') {
        return 'Completed'
    } else if (status == 'approved') {
        return 'Approved'
    } else if (status == 'declined') {
        return 'Declined'
    } else if (status == 'approved') {
        return 'Approved'
    } else if (status == 'started') {
        return 'Started'
    } else if (status == 'cancelledByUser') {
        return 'Cancelled By User'
    } else if (status == 'cancelledByDriver') {
        return 'Cancelled By Driver'
    } else if (status == 'completed') {
        return 'Completed'
    } else if (status == 'expired') {
        return 'Expired'
    } 
}